import './hero.css'
import bannerImg from '../../assets/images/banner-img.png'
import bannerOneBgShape2 from '../../assets/images/banner-one-bg-shape-2.png'
import bannerOneBgShape3 from '../../assets/images/banner-one-bg-shape-3.png'
import happyUser from '../../assets/images/happy-user.svg'
import happyUserImg1 from '../../assets/images/happy-user-img-1.png'
import happyUserImg2 from '../../assets/images/happy-user-img-2.png'
import happyUserImg3 from '../../assets/images/happy-user-img-3.png'
import happyUserImg4 from '../../assets/images/happy-user-img-4.png'
import happyUserImg5 from '../../assets/images/happy-user-img-5.png'
import { Link } from 'react-router-dom'

const Hero = () => {
    return (
        <div className="banner-area">
            <div className="container-fluid">
                <div className="row align-items-center">
                    <div className="col-lg-6">
                        <div className="single-banner-content">
                            <span>Get Amazing Cleaning Services</span>
                            <h1>We Are Your Key To Clean</h1>
                            <p>Lorem ipsum dolor sit amet consectetur adipi scing elit ut elit tellus luctus nec ullamcorper mattis pulvinar dapibus   orem ipsum dolor sit amet consectetur adipi scing adipi scing elit.</p>
                            <Link to="/services" className="default-btn btn-style-one">Our Best Offers</Link>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="single-banner-img">
                            <div className="banner-main-img">
                                <img src={bannerImg} alt="images" />
                            </div>
                            <div className="banner-img-shape-1">
                                <img src={bannerOneBgShape3} alt="images" />
                            </div>
                            <div className="happy-user-card" >
                                <h2>Happy User <img src={happyUser} alt="images" /></h2>
                                <ul>
                                    <li><a href="#"><img src={happyUserImg1} alt="images" /></a></li>
                                    <li><a href="#"><img src={happyUserImg2} alt="images" /></a></li>
                                    <li><a href="#"><img src={happyUserImg3} alt="images" /></a></li>
                                    <li><a href="#"><img src={happyUserImg4} alt="images" /></a></li>
                                    <li><a href="#"><img src={happyUserImg5} alt="images" /></a></li>
                                    <li><a href="#"><i className="flaticon-plus"></i></a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="banner-bg-shape-2">
                <img src={bannerOneBgShape2} alt="images" />
            </div>
        </div>
    )
}

export default Hero